
import mainblock from './mainblock.js'
import minies from './minies.js'
import media from './media.js'

const state = {
        
    color:'#fff',
    name:'Adresses',
    showminies: false,
    showmedia: false,
    vuexnamespace: 'adresses',
    initmutation:'adresses/ADRESS_INIT_ADRESS',
    backlink:'adresses',   
    duplicateable:false,
    helptext:"Adressen werden in diesem Programm seperat gepflegt und später den Lieferanten oder Kunden\n\
            zugeordnet. <br> Die Felder Strasse, PLZ und Ort sind Pflichtfelder, während die Daten für das Land\n\
            sowie die Geokoordinaten (Breiten- und Längengrad) optional für die spätere Verwendung gespeichert\n\
            werden können. <br>Gespeichert wird mit dem Haken-Button. <br>Mit dem 'schwarzen Kreuz' wird das Formular\n\
            ohne zu speichern verlassen."

    
};

export default {
    namespaced: true,
    modules: {
        mainblock: mainblock,
        minies:minies,
        media:media        
    },
    state,
  
};